module.exports = __webpack_public_path__ + "media/video.1f2eb4ce.mp4";